<template>
    <div>
        <div class="results-grid">
            <slot :items="visibleItems"></slot>
        </div>
        <div v-if="hasMore || isExpanded" class="showMoreButton" @click="toggle">
            <span>{{ hasMore ? 'Show more' : 'Show less' }}</span>
        </div>
    </div>
</template>

<script>
// Сетка карточек выдачи с порционным показом. Общая для плейлиста (MainResults.vue)
// и текстового поиска (SearchResults.vue): раньше этот блок был скопирован в оба.
//
// Карточка заметно тяжелее плоской разметки — своё состояние, подписка на дропдауны,
// нормализация форматов, — поэтому монтируем не весь список сразу и не разворачиваем
// остаток одним кликом, а добавляем по limit за раз.
//
// Виртуализации здесь нет намеренно: показанные карточки не размонтируются, поэтому
// при достаточном числе нажатий 'Show more' в DOM окажется весь список. Для выдач
// того размера, который отдаёт /api/convert, это дешевле окна с пересчётом позиций;
// если появятся выдачи на сотни элементов, порционного показа станет мало.
export default {
    name: 'ResultsGrid',
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        limit: {
            type: Number,
            default: 12,
        },
    },
    data() {
        return {
            shown: this.limit,
        };
    },
    computed: {
        visibleItems() {
            return this.items.slice(0, this.shown);
        },
        hasMore() {
            return this.items.length > this.shown;
        },
        isExpanded() {
            return this.shown > this.limit;
        },
    },
    watch: {
        // новая выдача не должна наследовать раскрытие от предыдущей
        items() {
            this.shown = this.limit;
        },
    },
    methods: {
        toggle() {
            this.shown = this.hasMore ? this.shown + this.limit : this.limit;
        },
    },
};
</script>
